import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import JobWorkerOfferContactDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferContactDeclinedReason";

export default class UpdateJobWorkerOfferContactConfirmationRequest extends BaseUpdateRequest {
    jobWorkerOfferId = '';
    confirmed = false;
    declinedReason: JobWorkerOfferContactDeclinedReason;
}